import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CasingCredit } from '../../../features/product-data/models/casing-credit.model';
import { CustomerAssignService } from '../../services/customer-assign.service';
import { Subscription } from 'rxjs';
import { AdditionalColumn, BreadcrumbLink } from '../../models/response.model';
import { PreferredTreadSpecification } from '../../../features/product-data/models/response.model';
import { FreeRepair } from '../../../features/product-data/models/response.model';
import { FinishedProduct } from '../../../features/product-data/models/finished-product.model';
import { CasingGradeTable } from '../../../features/product-data/models/casing-grade-table.model';
import { CasingPurchase } from '../../../features/product-data/models/casing-purchase.model';

type PossibleDataObjects =
  | CasingCredit
  | PreferredTreadSpecification
  | FreeRepair
  | FinishedProduct
  | CasingGradeTable
  | CasingPurchase
  | null;

@Component({
  selector: 'app-customer-assign-wrapper',
  template: `
    <app-customer-assign
      [currentDataObject]="currentDataObject"
      [breadcrumbLinks]="breadcrumbLinks"
      [additionalColumns]="additionalColumns"
      [searchUri]="searchUri"
      [assignUri]="assignUri"
      [service]="service"
    ></app-customer-assign>
  `,
  standalone: false
})
export class CustomerAssignWrapperComponent implements OnInit, OnDestroy {
  breadcrumbLinks: BreadcrumbLink[] = [];
  currentDataObject: PossibleDataObjects;
  additionalColumns: AdditionalColumn[] = [];
  searchUri: string = '';
  assignUri: string = '';
  service: string = '';
  private subscription: Subscription;
  private readonly customerAssignService = inject(CustomerAssignService);
  constructor() {}

  ngOnInit(): void {
    this.subscription = this.customerAssignService.navigationData$.subscribe((data) => {
      if (data) {
        this.breadcrumbLinks = data.breadcrumbLinks || [];
        this.currentDataObject = data.currentDataObject || null;
        this.additionalColumns = data.additionalColumns || [];
        this.searchUri = data.searchUri || '';
        this.assignUri = data.assignUri || '';
        this.service = data.service || '';
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
